import {
  SofturaTable,
  PrimaryButton,
  Label,
  PopupDialogbox
} from "../../../../../../CommonComponents";
import '../AddEditUser.scss'
import { ModalPopup } from "../../../../../../../client/CommonComponents";
import AddSecurityRolePopup from "./AddSecurityRolePopup";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import './SecurityRoleGrid.scss'
import userManageOperations from '../../../../../../../redux/UserManagement/operations'
import permissions, { isAuthorized } from "client/utils/Permissions";

interface IProps {
  togglePopup?: any;
  securityRoleData?: any;
  columns?: any;
  showRolePopup?: any;
  handleClickSave?: any;
  setSelectedKeys?: any;
  selectedKeys?: any;
  roleError?: any;
  setRoleError?: any;
  showDeleteModal?: any;
  handleDeleteModal?: any;
  onRoleChange?: any;
  rolesData?: any;
  addSecurityRoleVal?: any;
  handleFailurePopup?: any;
  handleClickPopup?: any;
  selectedUserId?: any;
  securityRoleById?: any;
  actionType?: any;
  rolesEditData?: any;
  handleDeleteClick?: any;
  handleInfoModal?: any;
  showInfoModal?: any;
  selectedRoleName?: any;
  roleForm?: any;
  onEditRoleChange?: any;
  userForm?: any;
  addUserData?: any;
  Popupcontent?: any
}
const SecurityRoleGrid = ({
  Popupcontent,
  togglePopup,
  addUserData,
  onEditRoleChange,
  actionType,
  selectedRoleName,
  handleInfoModal,
  showInfoModal,
  securityRoleById,
  userForm,
  selectedUserId,
  rolesEditData,
  securityRoleData,
  addSecurityRoleVal,
  roleForm,
  rolesData,
  columns,
  showRolePopup,
  handleDeleteClick,
  handleClickSave,
  onRoleChange,
  setSelectedKeys,
  selectedKeys,
  roleError,
  setRoleError,
  showDeleteModal,
  handleDeleteModal }: IProps) => {
  const dispatch = useDispatch();
  const dispatchGetSecurityRoleList = userManageOperations.dispatchGetSecurityRoleList(dispatch);

  useEffect(() => {
    dispatchGetSecurityRoleList(selectedUserId || addUserData)
  }, [])

  return (
    <div className="app-grid-container">
      <div className="mb-1 Securitygrid">
        <div>
          <div className="user-details">  
            <p>First Name : <span>{userForm?.firstName ? userForm?.firstName : "-"}</span></p>
            <p className="SecurityLastName">Last Name : <span> {userForm?.lastName ? userForm?.lastName : "-"}</span></p>
            <p className="SecurityEmail">Email : <span>{userForm?.email ? userForm?.email : "-"}</span></p>
            <p className="SecurityJobTitle">Job Title : <span> {userForm?.jobTitle ? userForm?.jobTitle : "-"}</span></p>
          </div>
          <PrimaryButton
            text="Add Role"
            className="pull-right SecurityAddRole"
            onClick={() => togglePopup()}
            disabled={!isAuthorized(permissions.Create_Edit_Admin)}
           data-attribute="SecurityRoleGrid_Default_Button" />
        </div>
        <div
          className={
            securityRoleData?.data?.length !== 0 ? " sec-role-grid softura-table" : "softura-table sec-role-grid paginationNav"
          }
        >
          <SofturaTable
            data={securityRoleData?.data ?? []}
            columns={columns}
            sort={true}
            defaultPageSize={10}
            pageSizes={[10, 20, 50]}
            globalSearch={false}
            filter={true}
           data-attribute="SecurityRoleGrid_Default_Grid" />
        </div>
        {showRolePopup ? (
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle={(securityRoleById?.roleId != 0 && securityRoleById?.hasOwnProperty("roleId")) ? "Edit Security Role Group" : "Add New Security Role Group"}
            ModalPopupType="medium"
            FooterSecondaryBtnTxt="Cancel"
            FooterPrimaryBtnTxt="Save"
            closeModalPopup={togglePopup}
            PrimaryBtnOnclick={handleClickSave}
            SecondryBtnOnclick={togglePopup}
           data-attribute="SecurityRoleGrid_Default_ModalPopup">
            <AddSecurityRolePopup onEditRoleChange={onEditRoleChange} addUserData={addUserData} setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} roleError={roleError} setRoleError={setRoleError} onRoleChange={onRoleChange} rolesData={rolesData} securityRoleById={securityRoleById} actionType={actionType} selectedUserId={selectedUserId} rolesEditData={rolesEditData} roleForm={roleForm} />
          </ModalPopup>
        ) : null}
        {showDeleteModal ? (
          <ModalPopup
            ShowModalPopupFooter={true}
            ModalPopupTitle="Delete Category"
            ModalPopupType="medium"
            FooterSecondaryBtnTxt="No"
            FooterPrimaryBtnTxt="Yes"
            closeModalPopup={handleDeleteModal}
            PrimaryBtnOnclick={handleDeleteClick}
            SecondryBtnOnclick={handleDeleteModal}
           data-attribute="SecurityRoleGrid_Default_ModalPopup_2">
            <Label data-attribute="SecurityRoleGrid_Default_Label">Are you sure you want to delete "{selectedRoleName}" ?</Label>
          </ModalPopup>
        ) : (
          ""
        )}
        <div className="secRoleInfo-Modal">
          {showInfoModal ? (
            <ModalPopup
              ShowModalPopupFooter={true}
              ModalPopupTitle="Information"
              ModalPopupType="medium"
              FooterPrimaryBtnTxt="Ok"
              closeModalPopup={handleInfoModal}
              PrimaryBtnOnclick={handleInfoModal}
             data-attribute="SecurityRoleGrid_Default_ModalPopup_3">
              <Label data-attribute="SecurityRoleGrid_Default_Label_2">Successfully deleted "{selectedRoleName}"</Label>
            </ModalPopup>
          ) : (
            ""
          )
          }
        </div>
        {addSecurityRoleVal != 0 || addSecurityRoleVal == "error" ? (
          <PopupDialogbox
          hideDialog={!Popupcontent.isDialogVisible}
          onDismiss={() => Popupcontent?.popupOutlinebtnOnclick()}
          Popupcontent={Popupcontent}
          popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
          popupPrimarybtnOnclick={(
            item: any,
            actionby: string,
            value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
              actionby,
              value)}
         data-attribute="SecurityRoleGrid_Default_PopupDilalogBox" />
        ) : null}
      </div>
    </div>
  );
};

export default SecurityRoleGrid